var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8982 0.999999L12.8982 9.8M17 8.2L17 2.6C17 1.71634 16.2654 1 15.3593 1L4.34504 0.999999C3.13034 0.999999 2.09731 1.86426 1.91261 3.03506L1.02915 8.63506C0.799793 10.0889 1.95324 11.4 3.46159 11.4L6.33542 11.4C6.78849 11.4 7.15577 11.7582 7.15577 12.2L7.15577 15.0273C7.15577 16.1168 8.06143 17 9.17863 17C9.4451 17 9.68657 16.847 9.7948 16.6095L12.6817 10.2751C12.8134 9.98619 13.1072 9.8 13.4314 9.8L15.3593 9.8C16.2654 9.8 17 9.08366 17 8.2Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumbDown.2d3f6cb5f474551284c8a558f8977bb8.svg";
export { ForwardRef as ReactComponent };